import { client } from "../../sanityClient";
import { formatDateBS } from "../../utils/dateUtils";
import "./GrainTable.css";

export default function GrainTable({
    data,
    loading,
    currentPage,
    totalPages,
    onPageChange,
    onDelete,
    onEdit,
    allFilteredData
}) {
    const fullTotal = allFilteredData.reduce((acc, t) => {
        const price = +t.finalPrice;
        return t.buyOrSell === "Buy" ? acc - price : acc + price;
    }, 0);

    const totalText = fullTotal >= 0
        ? `+ ₹${Math.abs(fullTotal).toLocaleString()}`
        : `- ₹${Math.abs(fullTotal).toLocaleString()}`;
    const totalColor = fullTotal >= 0 ? "text-success" : "text-danger";

    const handleEdit = async (t) => {
        try {
            const fullTx = await client.fetch(
                `*[_id == $id][0]{
          _id, GTrID, buyOrSell, quantity, rate, finalPrice, time, remarks,
          grain-> { _id, grainName }
        }`,
                { id: t._id }
            );
            onEdit(fullTx);
        } catch (err) {
            console.error(err);
            alert("Failed to load grain");
        }
    };

    if (loading) {
        return (
            <div className="text-center my-5">
                <div className="spinner-border text-primary" />
            </div>
        );
    }

    return (
        <div className="grain-table-wrapper">
            <div className="table-responsive">
                <table className="grain-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Type</th>
                            <th>Grain</th>
                            <th>Qty</th>
                            <th>Rate</th>
                            <th>Final</th>
                            <th>Date</th>
                            <th>Remarks</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 ? (
                            <tr>
                                <td colSpan="9" className="text-center py-4">
                                    No transactions
                                </td>
                            </tr>
                        ) : (
                            <>
                                {data.map((t) => (
                                    <tr key={t._id}>
                                        <td>{t.GTrID}</td>
                                        <td>
                                            <span className={`badge ${t.buyOrSell === "Buy" ? "badge-buy" : "badge-sell"}`}>
                                                {t.buyOrSell}
                                            </span>
                                        </td>
                                        <td>{t.grain?.grainName || "-"}</td>
                                        <td>{t.quantity} kg</td>
                                        <td>₹{t.rate}</td>
                                        <td>
                                            <span className={`badge ${t.buyOrSell === "Buy" ? "badge-buy" : "badge-sell"}`}>
                                                {t.buyOrSell === "Buy" ? "-" : "+"}₹{t.finalPrice}
                                            </span>
                                        </td>
                                        <td>{formatDateBS(t.time)}</td>
                                        <td>{t.remarks || "-"}</td>
                                        <td>
                                            <button className="action-btn edit-btn" onClick={() => handleEdit(t)}>
                                                <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M12.146 0.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                                                </svg>
                                            </button>
                                            <button className="action-btn delete-btn" onClick={() => onDelete(t._id)}>
                                                <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                    <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                </svg>
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                                <tr className="total-row">
                                    <td colSpan="6" className="fw-bold text-end">Total</td>
                                    <td className={`fw-bold ${totalColor} fs-5`}>
                                        {totalText}
                                    </td>
                                    <td colSpan="3"></td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </div>

            {totalPages > 1 && (
                <nav className="mt-4">
                    <ul className="pagination justify-content-center grain-pagination">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => onPageChange(currentPage - 1)}>
                                <i className="bi bi-chevron-left"></i>
                            </button>
                        </li>
                        {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                                <button className="page-link" onClick={() => onPageChange(i + 1)}>
                                    {i + 1}
                                </button>
                            </li>
                        ))}
                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => onPageChange(currentPage + 1)}>
                                <i className="bi bi-chevron-right"></i>
                            </button>
                        </li>
                    </ul>
                </nav>
            )}
        </div>
    );
}